import { INotificationDto } from "@/models/dto/INotification.dto"
import globalModule from "@/store/modules/global.module"
import RestClient from "../rest.client"

export default class NotificationService {
    static async getAllNotifications() {
        return await RestClient.call({
            url: '/notifications/getAll',
            method: 'get',
            params: { userId: globalModule.user.id },
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    static async createNotification(notification: INotificationDto, deviceIds: number[]) {
        return await RestClient.call({
            url: '/notifications/create',
            method: 'post',
            data: notification,
            headers: { 'Authorization': localStorage.getItem('token') },
            params: { deviceIds: deviceIds.join(',') },
        })
    }

    static async editNotification(notification: INotificationDto, deviceIds: number[]) {
        return await RestClient.call({
            url: '/notifications/edit',
            method: 'put',
            data: notification,
            headers: { 'Authorization': localStorage.getItem('token') },
            params: { deviceIds: deviceIds.join(',') },
        })
    }

    static async deleteNotification(notificationId: number) {
        return await RestClient.call({
            url: `/notifications/${notificationId}`,
            method: 'delete',
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    // static async assingDevice(notificationId: number, deviceId: number) {
    //     return await RestClient.call({
    //         url: '/notes/' + noteId.toString(),
    //         method: 'delete',
    //         headers: { 'Authorization': localStorage.getItem('token') }
    //     })
    // }


} 